import { getRequestHeader } from '../base';

const JKC_BELONG_CODE_STORAGE_KEY = 'jkc:thirdPartnerBelongCode';

interface JKCBelongCodeState {
  belongCode: string;
  operatorId?: string;
  siteId?: string;
  userAccount?: string;
}

function getStorage(): Storage | null {
  if (typeof window === 'undefined' || !window.localStorage) {
    return null;
  }
  return window.localStorage;
}

function getCurrentUserIdentity() {
  const headers = getRequestHeader();
  return {
    operatorId: headers.operatorId,
    siteId: headers.siteId,
    userAccount: headers.userAccount
  };
}

function readBelongCodeState(): JKCBelongCodeState | null {
  const storage = getStorage();
  if (!storage) {
    return null;
  }

  try {
    const raw = storage.getItem(JKC_BELONG_CODE_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    return JSON.parse(raw);
  } catch (error) {
    storage.removeItem(JKC_BELONG_CODE_STORAGE_KEY);
    return null;
  }
}

export function setJKCBelongCode(belongCode: string | number | null | undefined) {
  const storage = getStorage();
  if (!storage) {
    return;
  }

  if (belongCode === null || belongCode === undefined || belongCode === '') {
    storage.removeItem(JKC_BELONG_CODE_STORAGE_KEY);
    return;
  }

  const identity = getCurrentUserIdentity();
  const state: JKCBelongCodeState = {
    belongCode: String(belongCode),
    operatorId: identity.operatorId,
    siteId: identity.siteId,
    userAccount: identity.userAccount
  };
  storage.setItem(JKC_BELONG_CODE_STORAGE_KEY, JSON.stringify(state));
}

export function getJKCBelongCode(): string {
  const state = readBelongCodeState();
  if (!state || !state.belongCode) {
    return '';
  }

  const identity = getCurrentUserIdentity();
  if (
    state.operatorId !== identity.operatorId ||
    state.siteId !== identity.siteId ||
    state.userAccount !== identity.userAccount
  ) {
    return '';
  }

  return state.belongCode;
}

export function getJKCRequestHeaders(
  extraHeaders?: Record<string, string>
): Record<string, string> {
  const headers = Object.assign({}, getRequestHeader(), extraHeaders || {});
  const belongCode = getJKCBelongCode();

  if (belongCode) {
    headers.thirdPartnerBelongCode = belongCode;
  }

  return headers;
}
